import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { DISCLAIMER_PARAGRAPHS, DISCLAIMER_TITLE } from 'src/utils/disclaimer';

// An info icon that shows the disclaimer when it is hovered, focused or tapped
const DisclaimerInfo = ({ color }) => (
  <Tooltip
    arrow
    placement="bottom-start"
    enterTouchDelay={0}
    // the career window sits on layer 10000
    PopperProps={{ sx: { zIndex: 20000 } }}
    leaveTouchDelay={12000}
    componentsProps={{
      tooltip: { sx: { maxWidth: 420, p: 1.75, bgcolor: '#12151c', textAlign: 'left' } },
      arrow: { sx: { color: '#12151c' } },
    }}
    title={
      <Box>
        <Typography component="p" sx={{ fontSize: '13px !important', lineHeight: '1.4 !important', fontWeight: 700, mb: 0.75 }}>{DISCLAIMER_TITLE}</Typography>
        {DISCLAIMER_PARAGRAPHS.map((paragraph) => (
          <Typography component="p" key={paragraph.slice(0, 24)} sx={{ fontSize: '12.5px !important', lineHeight: '1.5 !important', fontWeight: 400, mb: 0.75, textAlign: 'left' }}>{paragraph}</Typography>
        ))}
      </Box>
    }
  >
    <IconButton aria-label={DISCLAIMER_TITLE} size="small" sx={{ ml: 1, color: color || 'inherit' }}>
      <InfoOutlinedIcon />
    </IconButton>
  </Tooltip>
);

DisclaimerInfo.propTypes = { color: PropTypes.string };

export default DisclaimerInfo;
